module.exports = __webpack_public_path__ + "img/nurse_black.6eb42772.svg";